// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fctl-form {
  width: 100%;
  container-type: inline-size;
  container-name: fctl-form;
}

.fctl-form__content {
  width: 100%;
}

/*
 * Constrain line length only in genuinely wide form areas (e.g. full-page forms).
 * Wizard and split-view hosts are often < 75rem even on large monitors, so keep
 * those at full width. Breakpoints are container-based, not viewport-based.
 */
@container fctl-form (min-width: 75rem) {
  .fctl-form--responsive .fctl-form__content {
    width: 83.333%;
  }
}

@container fctl-form (min-width: 90rem) {
  .fctl-form--responsive .fctl-form__content {
    width: 75%;
  }
}

@container fctl-form (min-width: 105rem) {
  .fctl-form--responsive .fctl-form__content {
    width: 66.666%;
  }
}

.fctl-form-section {
  margin-block-start: var(--pf-t--global--spacer--sm);
  padding-inline-start: var(--pf-t--global--spacer--lg);
}
`, "",{"version":3,"sources":["webpack://./../../libs/ui-components/src/components/form/FlightCtlForm.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE;AACF;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,mDAAmD;EACnD,qDAAqD;AACvD","sourcesContent":[".fctl-form {\n  width: 100%;\n  container-type: inline-size;\n  container-name: fctl-form;\n}\n\n.fctl-form__content {\n  width: 100%;\n}\n\n/*\n * Constrain line length only in genuinely wide form areas (e.g. full-page forms).\n * Wizard and split-view hosts are often < 75rem even on large monitors, so keep\n * those at full width. Breakpoints are container-based, not viewport-based.\n */\n@container fctl-form (min-width: 75rem) {\n  .fctl-form--responsive .fctl-form__content {\n    width: 83.333%;\n  }\n}\n\n@container fctl-form (min-width: 90rem) {\n  .fctl-form--responsive .fctl-form__content {\n    width: 75%;\n  }\n}\n\n@container fctl-form (min-width: 105rem) {\n  .fctl-form--responsive .fctl-form__content {\n    width: 66.666%;\n  }\n}\n\n.fctl-form-section {\n  margin-block-start: var(--pf-t--global--spacer--sm);\n  padding-inline-start: var(--pf-t--global--spacer--lg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
